// portfolioMockData.js — Institutional-grade mock data for portfolio analytics demo

// ─── Entity Definitions ──────────────────────────────────────────────────────
export const ENTITIES = {
  meridian: { id: 'ENT-001', name: 'Meridian Capital Partners', type: 'Family Office' },
  emFixed: { id: 'ENT-002', name: 'Meridian EM Fixed Income', type: 'Sub-Fund' },
  individual: { id: 'ENT-003', name: 'Akinyi Odera (Personal)', type: 'Individual Account' },
};

// ─── Portfolio Positions (~30 across 9 markets, 3 entities) ──────────────────

export const PORTFOLIO_POSITIONS = [
  // ── Entity 1: Meridian Capital Partners (12 positions, ~$4.2M) ──
  {
    id: 'POS-001', entity: 'ENT-001', country: 'Kenya', instrument: '91-Day T-Bill',
    isin: 'KE0000000001', currency: 'KES', faceValue: 50000000, purchasePrice: 48250000,
    purchaseDate: '2026-03-15', maturityDate: '2026-06-14', couponRate: 0,
    yieldToMaturity: 0.1625, status: 'matured', fxRateAtPurchase: 129.50, currentFxRate: 131.20,
    custodianBank: 'Standard Chartered Kenya', auctionRef: 'CBK-2026-T91-012',
  },
  {
    id: 'POS-002', entity: 'ENT-001', country: 'Kenya', instrument: '182-Day T-Bill',
    isin: 'KE0000000002', currency: 'KES', faceValue: 80000000, purchasePrice: 74960000,
    purchaseDate: '2026-04-10', maturityDate: '2026-10-09', couponRate: 0,
    yieldToMaturity: 0.1580, status: 'active', fxRateAtPurchase: 130.10, currentFxRate: 131.20,
    custodianBank: 'Standard Chartered Kenya', auctionRef: 'CBK-2026-T182-008',
  },
  {
    id: 'POS-003', entity: 'ENT-001', country: 'Kenya', instrument: '364-Day T-Bill',
    isin: 'KE0000000003', currency: 'KES', faceValue: 120000000, purchasePrice: 104400000,
    purchaseDate: '2026-01-20', maturityDate: '2027-01-19', couponRate: 0,
    yieldToMaturity: 0.1640, status: 'active', fxRateAtPurchase: 128.80, currentFxRate: 131.20,
    custodianBank: 'KCB Bank', auctionRef: 'CBK-2026-T364-003',
  },
  {
    id: 'POS-004', entity: 'ENT-001', country: 'Nigeria', instrument: '91-Day T-Bill',
    isin: 'NG0000000001', currency: 'NGN', faceValue: 250000000, purchasePrice: 237500000,
    purchaseDate: '2026-06-01', maturityDate: '2026-08-30', couponRate: 0,
    yieldToMaturity: 0.2100, status: 'maturing', fxRateAtPurchase: 1550.00, currentFxRate: 1580.00,
    custodianBank: 'Stanbic IBTC', auctionRef: 'CBN-2026-NTB91-024',
  },
  {
    id: 'POS-005', entity: 'ENT-001', country: 'Nigeria', instrument: '364-Day T-Bill',
    isin: 'NG0000000002', currency: 'NGN', faceValue: 400000000, purchasePrice: 340000000,
    purchaseDate: '2026-02-15', maturityDate: '2027-02-14', couponRate: 0,
    yieldToMaturity: 0.2250, status: 'active', fxRateAtPurchase: 1520.00, currentFxRate: 1580.00,
    custodianBank: 'Stanbic IBTC', auctionRef: 'CBN-2026-NTB364-006',
  },
  {
    id: 'POS-006', entity: 'ENT-001', country: 'Ghana', instrument: '182-Day T-Bill',
    isin: 'GH0000000001', currency: 'GHS', faceValue: 2000000, purchasePrice: 1780000,
    purchaseDate: '2026-05-01', maturityDate: '2026-10-28', couponRate: 0,
    yieldToMaturity: 0.2780, status: 'active', fxRateAtPurchase: 14.80, currentFxRate: 15.20,
    custodianBank: 'Ecobank Ghana', auctionRef: 'BOG-2026-TB182-018',
  },
  {
    id: 'POS-007', entity: 'ENT-001', country: 'Ghana', instrument: '2-Year Bond',
    isin: 'GH0000000002', currency: 'GHS', faceValue: 3000000, purchasePrice: 2850000,
    purchaseDate: '2025-09-15', maturityDate: '2027-09-14', couponRate: 0.2950,
    yieldToMaturity: 0.2850, status: 'active', fxRateAtPurchase: 13.50, currentFxRate: 15.20,
    custodianBank: 'Ecobank Ghana', auctionRef: 'BOG-2025-FXR2Y-007',
  },
  {
    id: 'POS-008', entity: 'ENT-001', country: 'Rwanda', instrument: '91-Day T-Bill',
    isin: 'RW0000000001', currency: 'RWF', faceValue: 150000000, purchasePrice: 144750000,
    purchaseDate: '2026-07-01', maturityDate: '2026-09-29', couponRate: 0,
    yieldToMaturity: 0.1150, status: 'maturing', fxRateAtPurchase: 1340.00, currentFxRate: 1355.00,
    custodianBank: 'Bank of Kigali', auctionRef: 'BNR-2026-TB91-027',
  },
  {
    id: 'POS-009', entity: 'ENT-001', country: 'Uganda', instrument: '182-Day T-Bill',
    isin: 'UG0000000001', currency: 'UGX', faceValue: 500000000, purchasePrice: 462500000,
    purchaseDate: '2026-05-20', maturityDate: '2026-11-16', couponRate: 0,
    yieldToMaturity: 0.1350, status: 'active', fxRateAtPurchase: 3780.00, currentFxRate: 3820.00,
    custodianBank: 'Stanbic Uganda', auctionRef: 'BOU-2026-TB182-014',
  },
  {
    id: 'POS-010', entity: 'ENT-001', country: 'Tanzania', instrument: '364-Day T-Bill',
    isin: 'TZ0000000001', currency: 'TZS', faceValue: 800000000, purchasePrice: 736000000,
    purchaseDate: '2026-03-01', maturityDate: '2027-02-28', couponRate: 0,
    yieldToMaturity: 0.1050, status: 'active', fxRateAtPurchase: 2630.00, currentFxRate: 2660.00,
    custodianBank: 'CRDB Bank', auctionRef: 'BOT-2026-TB364-009',
  },
  {
    id: 'POS-011', entity: 'ENT-001', country: 'South Africa', instrument: '5-Year Bond',
    isin: 'ZA0000000001', currency: 'ZAR', faceValue: 5000000, purchasePrice: 4750000,
    purchaseDate: '2025-06-01', maturityDate: '2030-05-31', couponRate: 0.0875,
    yieldToMaturity: 0.0950, status: 'active', fxRateAtPurchase: 18.20, currentFxRate: 18.50,
    custodianBank: 'Standard Bank SA', auctionRef: 'SARB-2025-R186-002',
  },
  {
    id: 'POS-012', entity: 'ENT-001', country: 'Egypt', instrument: '182-Day T-Bill',
    isin: 'EG0000000001', currency: 'EGP', faceValue: 10000000, purchasePrice: 8700000,
    purchaseDate: '2026-06-15', maturityDate: '2026-12-12', couponRate: 0,
    yieldToMaturity: 0.2680, status: 'active', fxRateAtPurchase: 48.50, currentFxRate: 49.10,
    custodianBank: 'CIB Egypt', auctionRef: 'CBE-2026-TB182-033',
  },

  // ── Entity 2: Meridian EM Fixed Income (10 positions, ~$2.8M) ──
  {
    id: 'POS-013', entity: 'ENT-002', country: 'Kenya', instrument: '364-Day T-Bill',
    isin: 'KE0000000004', currency: 'KES', faceValue: 60000000, purchasePrice: 52800000,
    purchaseDate: '2026-02-01', maturityDate: '2027-01-31', couponRate: 0,
    yieldToMaturity: 0.1610, status: 'active', fxRateAtPurchase: 129.00, currentFxRate: 131.20,
    custodianBank: 'Standard Chartered Kenya', auctionRef: 'CBK-2026-T364-002',
  },
  {
    id: 'POS-014', entity: 'ENT-002', country: 'Kenya', instrument: '2-Year Bond',
    isin: 'KE0000000005', currency: 'KES', faceValue: 75000000, purchasePrice: 71250000,
    purchaseDate: '2025-10-01', maturityDate: '2027-09-30', couponRate: 0.1625,
    yieldToMaturity: 0.1580, status: 'active', fxRateAtPurchase: 127.50, currentFxRate: 131.20,
    custodianBank: 'KCB Bank', auctionRef: 'CBK-2025-FXD2Y-019',
  },
  {
    id: 'POS-015', entity: 'ENT-002', country: 'Nigeria', instrument: '182-Day T-Bill',
    isin: 'NG0000000003', currency: 'NGN', faceValue: 300000000, purchasePrice: 270000000,
    purchaseDate: '2026-04-20', maturityDate: '2026-10-17', couponRate: 0,
    yieldToMaturity: 0.2180, status: 'active', fxRateAtPurchase: 1540.00, currentFxRate: 1580.00,
    custodianBank: 'Stanbic IBTC', auctionRef: 'CBN-2026-NTB182-015',
  },
  {
    id: 'POS-016', entity: 'ENT-002', country: 'Ghana', instrument: '91-Day T-Bill',
    isin: 'GH0000000003', currency: 'GHS', faceValue: 1500000, purchasePrice: 1417500,
    purchaseDate: '2026-07-10', maturityDate: '2026-10-08', couponRate: 0,
    yieldToMaturity: 0.2720, status: 'maturing', fxRateAtPurchase: 15.00, currentFxRate: 15.20,
    custodianBank: 'Ecobank Ghana', auctionRef: 'BOG-2026-TB91-031',
  },
  {
    id: 'POS-017', entity: 'ENT-002', country: 'Rwanda', instrument: '182-Day T-Bill',
    isin: 'RW0000000002', currency: 'RWF', faceValue: 200000000, purchasePrice: 188000000,
    purchaseDate: '2026-05-15', maturityDate: '2026-11-11', couponRate: 0,
    yieldToMaturity: 0.1180, status: 'active', fxRateAtPurchase: 1335.00, currentFxRate: 1355.00,
    custodianBank: 'Bank of Kigali', auctionRef: 'BNR-2026-TB182-012',
  },
  {
    id: 'POS-018', entity: 'ENT-002', country: 'Uganda', instrument: '364-Day T-Bill',
    isin: 'UG0000000002', currency: 'UGX', faceValue: 750000000, purchasePrice: 682500000,
    purchaseDate: '2026-03-10', maturityDate: '2027-03-09', couponRate: 0,
    yieldToMaturity: 0.1380, status: 'active', fxRateAtPurchase: 3760.00, currentFxRate: 3820.00,
    custodianBank: 'Stanbic Uganda', auctionRef: 'BOU-2026-TB364-007',
  },
  {
    id: 'POS-019', entity: 'ENT-002', country: 'South Africa', instrument: '10-Year Bond',
    isin: 'ZA0000000002', currency: 'ZAR', faceValue: 8000000, purchasePrice: 7360000,
    purchaseDate: '2025-03-01', maturityDate: '2035-02-28', couponRate: 0.1025,
    yieldToMaturity: 0.1080, status: 'active', fxRateAtPurchase: 17.80, currentFxRate: 18.50,
    custodianBank: 'Standard Bank SA', auctionRef: 'SARB-2025-R2030-001',
  },
  {
    id: 'POS-020', entity: 'ENT-002', country: 'Egypt', instrument: '364-Day T-Bill',
    isin: 'EG0000000002', currency: 'EGP', faceValue: 15000000, purchasePrice: 11550000,
    purchaseDate: '2026-03-20', maturityDate: '2027-03-19', couponRate: 0,
    yieldToMaturity: 0.2750, status: 'active', fxRateAtPurchase: 48.00, currentFxRate: 49.10,
    custodianBank: 'CIB Egypt', auctionRef: 'CBE-2026-TB364-011',
  },
  {
    id: 'POS-021', entity: 'ENT-002', country: 'Tanzania', instrument: '182-Day T-Bill',
    isin: 'TZ0000000002', currency: 'TZS', faceValue: 600000000, purchasePrice: 564000000,
    purchaseDate: '2026-06-01', maturityDate: '2026-11-28', couponRate: 0,
    yieldToMaturity: 0.1020, status: 'active', fxRateAtPurchase: 2640.00, currentFxRate: 2660.00,
    custodianBank: 'CRDB Bank', auctionRef: 'BOT-2026-TB182-016',
  },
  {
    id: 'POS-022', entity: 'ENT-002', country: 'Kenya', instrument: '91-Day T-Bill',
    isin: 'KE0000000006', currency: 'KES', faceValue: 40000000, purchasePrice: 38600000,
    purchaseDate: '2026-07-15', maturityDate: '2026-10-13', couponRate: 0,
    yieldToMaturity: 0.1590, status: 'maturing', fxRateAtPurchase: 130.80, currentFxRate: 131.20,
    custodianBank: 'Standard Chartered Kenya', auctionRef: 'CBK-2026-T91-030',
  },

  // ── Entity 3: Individual Personal Account (8 positions, ~$180K) ──
  {
    id: 'POS-023', entity: 'ENT-003', country: 'Kenya', instrument: '91-Day T-Bill',
    isin: 'KE0000000007', currency: 'KES', faceValue: 5000000, purchasePrice: 4825000,
    purchaseDate: '2026-06-20', maturityDate: '2026-09-18', couponRate: 0,
    yieldToMaturity: 0.1620, status: 'maturing', fxRateAtPurchase: 130.50, currentFxRate: 131.20,
    custodianBank: 'Equity Bank', auctionRef: 'CBK-2026-T91-026',
  },
  {
    id: 'POS-024', entity: 'ENT-003', country: 'Kenya', instrument: '182-Day T-Bill',
    isin: 'KE0000000008', currency: 'KES', faceValue: 8000000, purchasePrice: 7480000,
    purchaseDate: '2026-05-10', maturityDate: '2026-11-06', couponRate: 0,
    yieldToMaturity: 0.1560, status: 'active', fxRateAtPurchase: 130.00, currentFxRate: 131.20,
    custodianBank: 'Equity Bank', auctionRef: 'CBK-2026-T182-020',
  },
  {
    id: 'POS-025', entity: 'ENT-003', country: 'Kenya', instrument: '364-Day T-Bill',
    isin: 'KE0000000009', currency: 'KES', faceValue: 6000000, purchasePrice: 5220000,
    purchaseDate: '2026-02-28', maturityDate: '2027-02-27', couponRate: 0,
    yieldToMaturity: 0.1650, status: 'active', fxRateAtPurchase: 128.90, currentFxRate: 131.20,
    custodianBank: 'Equity Bank', auctionRef: 'CBK-2026-T364-005',
  },
  {
    id: 'POS-026', entity: 'ENT-003', country: 'Nigeria', instrument: '91-Day T-Bill',
    isin: 'NG0000000004', currency: 'NGN', faceValue: 15000000, purchasePrice: 14250000,
    purchaseDate: '2026-07-05', maturityDate: '2026-10-03', couponRate: 0,
    yieldToMaturity: 0.2050, status: 'maturing', fxRateAtPurchase: 1560.00, currentFxRate: 1580.00,
    custodianBank: 'GTBank', auctionRef: 'CBN-2026-NTB91-029',
  },
  {
    id: 'POS-027', entity: 'ENT-003', country: 'Nigeria', instrument: '182-Day T-Bill',
    isin: 'NG0000000005', currency: 'NGN', faceValue: 20000000, purchasePrice: 18000000,
    purchaseDate: '2026-04-15', maturityDate: '2026-10-12', couponRate: 0,
    yieldToMaturity: 0.2150, status: 'active', fxRateAtPurchase: 1545.00, currentFxRate: 1580.00,
    custodianBank: 'GTBank', auctionRef: 'CBN-2026-NTB182-013',
  },
  {
    id: 'POS-028', entity: 'ENT-003', country: 'Ghana', instrument: '91-Day T-Bill',
    isin: 'GH0000000004', currency: 'GHS', faceValue: 100000, purchasePrice: 93500,
    purchaseDate: '2026-07-20', maturityDate: '2026-10-18', couponRate: 0,
    yieldToMaturity: 0.2680, status: 'maturing', fxRateAtPurchase: 15.10, currentFxRate: 15.20,
    custodianBank: 'Fidelity Bank Ghana', auctionRef: 'BOG-2026-TB91-033',
  },
  {
    id: 'POS-029', entity: 'ENT-003', country: 'Rwanda', instrument: '91-Day T-Bill',
    isin: 'RW0000000003', currency: 'RWF', faceValue: 10000000, purchasePrice: 9700000,
    purchaseDate: '2026-06-10', maturityDate: '2026-09-08', couponRate: 0,
    yieldToMaturity: 0.1120, status: 'matured', fxRateAtPurchase: 1342.00, currentFxRate: 1355.00,
    custodianBank: 'Bank of Kigali', auctionRef: 'BNR-2026-TB91-025',
  },
  {
    id: 'POS-030', entity: 'ENT-003', country: 'Uganda', instrument: '91-Day T-Bill',
    isin: 'UG0000000003', currency: 'UGX', faceValue: 30000000, purchasePrice: 28950000,
    purchaseDate: '2026-07-01', maturityDate: '2026-09-29', couponRate: 0,
    yieldToMaturity: 0.1280, status: 'maturing', fxRateAtPurchase: 3800.00, currentFxRate: 3820.00,
    custodianBank: 'Stanbic Uganda', auctionRef: 'BOU-2026-TB91-022',
  },
];

// ─── Portfolio Performance (12 months TWR/MWR) ───────────────────────────────

export const PORTFOLIO_PERFORMANCE = [
  { month: 'Oct 2025', twr: 0.012, mwr: 0.011, cumTwr: 0.012, cumMwr: 0.011 },
  { month: 'Nov 2025', twr: 0.014, mwr: 0.013, cumTwr: 0.026, cumMwr: 0.024 },
  { month: 'Dec 2025', twr: 0.011, mwr: 0.012, cumTwr: 0.037, cumMwr: 0.036 },
  { month: 'Jan 2026', twr: 0.015, mwr: 0.014, cumTwr: 0.053, cumMwr: 0.050 },
  { month: 'Feb 2026', twr: 0.013, mwr: 0.012, cumTwr: 0.066, cumMwr: 0.062 },
  { month: 'Mar 2026', twr: 0.016, mwr: 0.015, cumTwr: 0.083, cumMwr: 0.078 },
  { month: 'Apr 2026', twr: 0.012, mwr: 0.011, cumTwr: 0.096, cumMwr: 0.089 },
  { month: 'May 2026', twr: 0.014, mwr: 0.013, cumTwr: 0.111, cumMwr: 0.103 },
  { month: 'Jun 2026', twr: 0.013, mwr: 0.014, cumTwr: 0.125, cumMwr: 0.118 },
  { month: 'Jul 2026', twr: 0.015, mwr: 0.014, cumTwr: 0.142, cumMwr: 0.133 },
  { month: 'Aug 2026', twr: 0.011, mwr: 0.010, cumTwr: 0.154, cumMwr: 0.144 },
  { month: 'Sep 2026', twr: 0.013, mwr: 0.012, cumTwr: 0.169, cumMwr: 0.157 },
];

// ─── Benchmark Returns (for comparison charts) ──────────────────────────────

export const BENCHMARK_RETURNS = [
  { month: 'Oct 2025', usd: 0.004, gbp: 0.003, chf: 0.001, aed: 0.004, jpy: -0.001 },
  { month: 'Nov 2025', usd: 0.004, gbp: 0.004, chf: 0.001, aed: 0.004, jpy: 0.000 },
  { month: 'Dec 2025', usd: 0.004, gbp: 0.003, chf: 0.001, aed: 0.004, jpy: -0.001 },
  { month: 'Jan 2026', usd: 0.004, gbp: 0.004, chf: 0.001, aed: 0.004, jpy: 0.000 },
  { month: 'Feb 2026', usd: 0.004, gbp: 0.003, chf: 0.002, aed: 0.004, jpy: 0.000 },
  { month: 'Mar 2026', usd: 0.004, gbp: 0.004, chf: 0.001, aed: 0.004, jpy: -0.001 },
  { month: 'Apr 2026', usd: 0.004, gbp: 0.003, chf: 0.001, aed: 0.004, jpy: 0.000 },
  { month: 'May 2026', usd: 0.004, gbp: 0.004, chf: 0.002, aed: 0.004, jpy: 0.000 },
  { month: 'Jun 2026', usd: 0.004, gbp: 0.003, chf: 0.001, aed: 0.004, jpy: -0.001 },
  { month: 'Jul 2026', usd: 0.004, gbp: 0.004, chf: 0.001, aed: 0.004, jpy: 0.000 },
  { month: 'Aug 2026', usd: 0.003, gbp: 0.003, chf: 0.001, aed: 0.003, jpy: 0.000 },
  { month: 'Sep 2026', usd: 0.004, gbp: 0.003, chf: 0.001, aed: 0.004, jpy: -0.001 },
];

// ─── FX Hedge Positions ──────────────────────────────────────────────────────

export const FX_HEDGES = [
  {
    id: 'FXH-001', currencyPair: 'KES/USD', direction: 'sell', notional: 200000000,
    notionalUsd: 1524390, forwardRate: 131.20, spotRateAtInception: 129.50,
    currentSpot: 131.20, maturityDate: '2026-12-15', status: 'active',
    mtmPnl: -25890, entity: 'ENT-001',
  },
  {
    id: 'FXH-002', currencyPair: 'NGN/USD', direction: 'sell', notional: 500000000,
    notionalUsd: 316456, forwardRate: 1600.00, spotRateAtInception: 1520.00,
    currentSpot: 1580.00, maturityDate: '2026-11-30', status: 'active',
    mtmPnl: 6329, entity: 'ENT-001',
  },
  {
    id: 'FXH-003', currencyPair: 'GHS/USD', direction: 'sell', notional: 3000000,
    notionalUsd: 197368, forwardRate: 15.60, spotRateAtInception: 14.80,
    currentSpot: 15.20, maturityDate: '2027-03-15', status: 'active',
    mtmPnl: -5197, entity: 'ENT-001',
  },
  {
    id: 'FXH-004', currencyPair: 'KES/USD', direction: 'sell', notional: 100000000,
    notionalUsd: 762195, forwardRate: 132.00, spotRateAtInception: 129.00,
    currentSpot: 131.20, maturityDate: '2027-01-31', status: 'active',
    mtmPnl: -4634, entity: 'ENT-002',
  },
  {
    id: 'FXH-005', currencyPair: 'ZAR/USD', direction: 'sell', notional: 8000000,
    notionalUsd: 432432, forwardRate: 19.00, spotRateAtInception: 18.20,
    currentSpot: 18.50, maturityDate: '2026-12-31', status: 'active',
    mtmPnl: 11712, entity: 'ENT-002',
  },
  {
    id: 'FXH-006', currencyPair: 'KES/USD', direction: 'sell', notional: 10000000,
    notionalUsd: 76628, forwardRate: 131.80, spotRateAtInception: 130.50,
    currentSpot: 131.20, maturityDate: '2026-11-06', status: 'active',
    mtmPnl: -349, entity: 'ENT-003',
  },
];

// ─── Cash Flow Schedule (12 months forward) ──────────────────────────────────

export const CASH_FLOW_SCHEDULE = [
  { date: '2026-09-18', type: 'Maturity', positionId: 'POS-023', instrument: '91-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 5000000, amountUsd: 38110, autoRoll: true },
  { date: '2026-09-29', type: 'Maturity', positionId: 'POS-008', instrument: '91-Day T-Bill', country: 'Rwanda', currency: 'RWF', amountLocal: 150000000, amountUsd: 110701, autoRoll: true },
  { date: '2026-09-29', type: 'Maturity', positionId: 'POS-030', instrument: '91-Day T-Bill', country: 'Uganda', currency: 'UGX', amountLocal: 30000000, amountUsd: 7853, autoRoll: false },
  { date: '2026-10-03', type: 'Maturity', positionId: 'POS-026', instrument: '91-Day T-Bill', country: 'Nigeria', currency: 'NGN', amountLocal: 15000000, amountUsd: 9494, autoRoll: true },
  { date: '2026-10-08', type: 'Maturity', positionId: 'POS-016', instrument: '91-Day T-Bill', country: 'Ghana', currency: 'GHS', amountLocal: 1500000, amountUsd: 98684, autoRoll: true },
  { date: '2026-10-09', type: 'Maturity', positionId: 'POS-002', instrument: '182-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 80000000, amountUsd: 609756, autoRoll: true },
  { date: '2026-10-12', type: 'Maturity', positionId: 'POS-027', instrument: '182-Day T-Bill', country: 'Nigeria', currency: 'NGN', amountLocal: 20000000, amountUsd: 12658, autoRoll: false },
  { date: '2026-10-13', type: 'Maturity', positionId: 'POS-022', instrument: '91-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 40000000, amountUsd: 304878, autoRoll: true },
  { date: '2026-10-17', type: 'Maturity', positionId: 'POS-015', instrument: '182-Day T-Bill', country: 'Nigeria', currency: 'NGN', amountLocal: 300000000, amountUsd: 189873, autoRoll: true },
  { date: '2026-10-18', type: 'Maturity', positionId: 'POS-028', instrument: '91-Day T-Bill', country: 'Ghana', currency: 'GHS', amountLocal: 100000, amountUsd: 6579, autoRoll: false },
  { date: '2026-10-28', type: 'Maturity', positionId: 'POS-006', instrument: '182-Day T-Bill', country: 'Ghana', currency: 'GHS', amountLocal: 2000000, amountUsd: 131579, autoRoll: true },
  { date: '2026-11-06', type: 'Maturity', positionId: 'POS-024', instrument: '182-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 8000000, amountUsd: 60976, autoRoll: true },
  { date: '2026-11-11', type: 'Maturity', positionId: 'POS-017', instrument: '182-Day T-Bill', country: 'Rwanda', currency: 'RWF', amountLocal: 200000000, amountUsd: 147601, autoRoll: false },
  { date: '2026-11-16', type: 'Maturity', positionId: 'POS-009', instrument: '182-Day T-Bill', country: 'Uganda', currency: 'UGX', amountLocal: 500000000, amountUsd: 130890, autoRoll: true },
  { date: '2026-11-28', type: 'Maturity', positionId: 'POS-021', instrument: '182-Day T-Bill', country: 'Tanzania', currency: 'TZS', amountLocal: 600000000, amountUsd: 225564, autoRoll: true },
  { date: '2026-12-12', type: 'Maturity', positionId: 'POS-012', instrument: '182-Day T-Bill', country: 'Egypt', currency: 'EGP', amountLocal: 10000000, amountUsd: 203666, autoRoll: true },
  { date: '2027-01-19', type: 'Maturity', positionId: 'POS-003', instrument: '364-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 120000000, amountUsd: 914634, autoRoll: true },
  { date: '2027-01-31', type: 'Maturity', positionId: 'POS-013', instrument: '364-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 60000000, amountUsd: 457317, autoRoll: false },
  { date: '2027-02-14', type: 'Maturity', positionId: 'POS-005', instrument: '364-Day T-Bill', country: 'Nigeria', currency: 'NGN', amountLocal: 400000000, amountUsd: 253165, autoRoll: true },
  { date: '2027-02-27', type: 'Maturity', positionId: 'POS-025', instrument: '364-Day T-Bill', country: 'Kenya', currency: 'KES', amountLocal: 6000000, amountUsd: 45732, autoRoll: true },
  { date: '2027-02-28', type: 'Maturity', positionId: 'POS-010', instrument: '364-Day T-Bill', country: 'Tanzania', currency: 'TZS', amountLocal: 800000000, amountUsd: 300752, autoRoll: false },
  { date: '2027-03-09', type: 'Maturity', positionId: 'POS-018', instrument: '364-Day T-Bill', country: 'Uganda', currency: 'UGX', amountLocal: 750000000, amountUsd: 196335, autoRoll: true },
  { date: '2027-03-15', type: 'Coupon', positionId: 'POS-007', instrument: '2-Year Bond', country: 'Ghana', currency: 'GHS', amountLocal: 442500, amountUsd: 29112, autoRoll: false },
  { date: '2027-03-19', type: 'Maturity', positionId: 'POS-020', instrument: '364-Day T-Bill', country: 'Egypt', currency: 'EGP', amountLocal: 15000000, amountUsd: 305499, autoRoll: true },
  { date: '2027-04-01', type: 'Coupon', positionId: 'POS-014', instrument: '2-Year Bond', country: 'Kenya', currency: 'KES', amountLocal: 6093750, amountUsd: 46447, autoRoll: false },
  { date: '2027-06-01', type: 'Coupon', positionId: 'POS-011', instrument: '5-Year Bond', country: 'South Africa', currency: 'ZAR', amountLocal: 437500, amountUsd: 23649, autoRoll: false },
  { date: '2027-09-14', type: 'Maturity', positionId: 'POS-007', instrument: '2-Year Bond', country: 'Ghana', currency: 'GHS', amountLocal: 3442500, amountUsd: 226480, autoRoll: false },
  { date: '2027-09-30', type: 'Maturity', positionId: 'POS-014', instrument: '2-Year Bond', country: 'Kenya', currency: 'KES', amountLocal: 81093750, amountUsd: 618092, autoRoll: false },
];

// ─── Risk Limits ─────────────────────────────────────────────────────────────

export const RISK_LIMITS = [
  { name: 'Single Country Exposure', limit: 0.35, current: 0.31, unit: '%', category: 'Concentration' },
  { name: 'Single Issuer Exposure', limit: 0.15, current: 0.09, unit: '%', category: 'Concentration' },
  { name: 'Max Portfolio Duration', limit: 2.5, current: 1.82, unit: 'years', category: 'Interest Rate' },
  { name: 'Foreign Exchange Hedge Ratio (min)', limit: 0.50, current: 0.62, unit: '%', category: 'Foreign Exchange' },
  { name: 'Max Single Foreign Exchange Exposure', limit: 0.25, current: 0.18, unit: '%', category: 'Foreign Exchange' },
  { name: 'Min Credit Rating', limit: null, current: 'B-', unit: 'rating', category: 'Credit' },
  { name: 'Max Maturity Concentration (30d)', limit: 0.20, current: 0.14, unit: '%', category: 'Liquidity' },
  { name: 'Portfolio VaR (95%, 1-day)', limit: 0.02, current: 0.013, unit: '%', category: 'Market Risk' },
];

// ─── Stress Scenarios ────────────────────────────────────────────────────────

export const STRESS_SCENARIOS = [
  {
    name: 'Rate Shock (+200bps)',
    description: 'Parallel upward shift of 200bps across all yield curves',
    portfolioValueImpact: -0.036,
    yieldChangeImpact: 0.020,
    fxImpact: -0.005,
    netImpact: -0.041,
  },
  {
    name: 'Foreign Exchange Depreciation (15%)',
    description: 'Broad-based 15% depreciation of African currencies vs USD',
    portfolioValueImpact: -0.008,
    yieldChangeImpact: 0.000,
    fxImpact: -0.092,
    netImpact: -0.100,
  },
  {
    name: 'Spread Widening (+150bps)',
    description: 'EM sovereign spreads widen by 150bps',
    portfolioValueImpact: -0.027,
    yieldChangeImpact: 0.015,
    fxImpact: -0.010,
    netImpact: -0.037,
  },
  {
    name: 'Combined Adverse',
    description: 'Rate shock + foreign exchange depreciation + spread widening simultaneously',
    portfolioValueImpact: -0.058,
    yieldChangeImpact: 0.025,
    fxImpact: -0.085,
    netImpact: -0.143,
  },
];

// ─── Governance & Operations ─────────────────────────────────────────────────

export const IPS_COMPLIANCE = {
  lastReviewDate: '2026-06-15',
  nextReviewDate: '2026-12-15',
  status: 'compliant',
  objectives: [
    { name: 'Target Return', target: '12–18% p.a. (USD)', actual: '16.9% (TWR)', status: 'compliant' },
    { name: 'Max Duration', target: '< 2.5 years', actual: '1.82 years', status: 'compliant' },
    { name: 'Min Credit Rating', target: 'B- or above', actual: 'B-', status: 'warning' },
    { name: 'Liquidity Reserve', target: '> 10% in < 91-day maturities', actual: '14%', status: 'compliant' },
    { name: 'Foreign Exchange Hedge Coverage', target: '> 50% of foreign exchange exposure', actual: '62%', status: 'compliant' },
    { name: 'Concentration Limit', target: '< 35% single country', actual: '31%', status: 'compliant' },
  ],
};

export const MANDATE_LIMITS = [
  { name: 'Eligible Markets', limit: '9 approved African markets', current: '8 active markets', status: 'OK', category: 'Universe' },
  { name: 'Instrument Types', limit: 'T-Bills & Sovereign Bonds only', current: 'T-Bills & Bonds', status: 'OK', category: 'Universe' },
  { name: 'Max Tenor', limit: '10 years', current: '10-Year Bond (ZA)', status: 'Warning', category: 'Duration' },
  { name: 'Min Investment Grade', limit: 'CCC+ or above (S&P equivalent)', current: 'B-', status: 'OK', category: 'Credit' },
  { name: 'Max Leverage', limit: 'No leverage permitted', current: 'None', status: 'OK', category: 'Leverage' },
  { name: 'Rebalancing Frequency', limit: 'Monthly review required', current: 'Last: Aug 2026', status: 'OK', category: 'Operations' },
];

export const COMMITTEE_SCHEDULE = [
  { date: '2026-07-15', type: 'Investment Committee', status: 'completed', attendees: 5, decisions: 'Approved Egypt T-Bill allocation increase to 8%' },
  { date: '2026-08-20', type: 'Risk Committee', status: 'completed', attendees: 4, decisions: 'Reviewed foreign exchange hedge ratios; approved GHS hedge extension' },
  { date: '2026-09-18', type: 'Board Meeting', status: 'upcoming', attendees: null, decisions: 'Q3 performance review & 2027 allocation strategy' },
  { date: '2026-10-15', type: 'Investment Committee', status: 'scheduled', attendees: null, decisions: null },
  { date: '2026-11-19', type: 'Compliance Review', status: 'scheduled', attendees: null, decisions: null },
];

export const AUDIT_TRAIL = [
  { timestamp: '2026-09-15T14:32:00Z', user: 'Amara Osei', action: 'Approved foreign exchange hedge rollover', category: 'Foreign Exchange', entity: 'ENT-001' },
  { timestamp: '2026-09-14T11:15:00Z', user: 'System', action: 'Auto-roll triggered for POS-023 (KES 91-Day T-Bill)', category: 'Settlement', entity: 'ENT-003' },
  { timestamp: '2026-09-13T09:45:00Z', user: 'James Mwangi', action: 'Updated risk limit: Single Country Exposure from 30% to 35%', category: 'Risk', entity: 'ENT-001' },
  { timestamp: '2026-09-12T16:20:00Z', user: 'Amara Osei', action: 'Placed bid CBK-2026-T91-035 for KES 50M', category: 'Trading', entity: 'ENT-001' },
  { timestamp: '2026-09-11T10:00:00Z', user: 'System', action: 'Daily VaR calculation completed: 1.3% (within limit)', category: 'Risk', entity: 'ALL' },
  { timestamp: '2026-09-10T15:30:00Z', user: 'Akinyi Odera', action: 'Viewed portfolio performance report', category: 'Reporting', entity: 'ENT-003' },
  { timestamp: '2026-09-09T11:45:00Z', user: 'James Mwangi', action: 'Approved new custodian relationship: CIB Egypt', category: 'Operations', entity: 'ENT-002' },
  { timestamp: '2026-09-08T14:00:00Z', user: 'Amara Osei', action: 'Submitted Q3 regulatory filing for ENT-001', category: 'Compliance', entity: 'ENT-001' },
];

export const REGULATORY_REPORTS = [
  { name: 'CMA Kenya Annual Report', jurisdiction: 'Kenya', dueDate: '2026-12-31', status: 'pending', lastFiled: '2025-12-28' },
  { name: 'SEC Nigeria Quarterly Filing', jurisdiction: 'Nigeria', dueDate: '2026-10-15', status: 'pending', lastFiled: '2026-07-14' },
  { name: 'BOG Ghana Investment Report', jurisdiction: 'Ghana', dueDate: '2026-09-30', status: 'in_progress', lastFiled: '2026-06-29' },
  { name: 'FSRA ADGM Semi-Annual', jurisdiction: 'UAE (ADGM)', dueDate: '2026-12-31', status: 'pending', lastFiled: '2026-06-30' },
  { name: 'BNR Rwanda Portfolio Disclosure', jurisdiction: 'Rwanda', dueDate: '2026-11-30', status: 'pending', lastFiled: '2025-11-28' },
];

export const SIGNATORY_AUTHORITY = [
  { name: 'Amara Osei', role: 'CIO', tier: 'Tier 1', limit: 'Unlimited', approvalScope: 'All transactions' },
  { name: 'James Mwangi', role: 'Head of Risk', tier: 'Tier 1', limit: 'Unlimited', approvalScope: 'Risk limit changes, new market approvals' },
  { name: 'Fatima Al-Rashid', role: 'Portfolio Manager', tier: 'Tier 2', limit: '$500,000', approvalScope: 'Single-sign trades up to limit' },
  { name: 'David Kimani', role: 'Operations Manager', tier: 'Tier 2', limit: '$250,000', approvalScope: 'Settlement instructions, custodian operations' },
  { name: 'Akinyi Odera', role: 'Analyst', tier: 'Tier 3', limit: '$0 (View only)', approvalScope: 'Read-only access, report generation' },
];
